"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  query getProducts($productCodes: [ID]) {\n    products(productCodes: $productCodes) {\n      ...Product\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productsQuery = void 0;
var _fetching = require("@ori/fetching");
var _product = require("./product");
/* istanbul ignore file */ const productsQuery = exports.productsQuery = (0, _fetching.gql)(_templateObject(), _product.product);
